// extracted by mini-css-extract-plugin
module.exports = {"mainTitle":"general-external-assessments_mainTitle__1sjvH"};